import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import { Course, Quiz } from 'models'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../../components/icon'
import { QuizSettings } from './quizSettingsEditor'
import { EditorQuizTask } from './quizTask'

export interface IQuizEditorProps {
  course?: Course
  passed?: boolean
}

export const QuizEditor = observer((props: IQuizEditorProps) => {
    const { course } = props;
    const { t } = useTranslation();
    const quiz: Quiz = course?.getCurStep?.quiz;

    if (!quiz) return null;

    return (
      <>
        <Container maxWidth='sm'>
          <Grid container>
            <Grid xs={12} mb={3} item>
              <Typography textAlign='center' variant='h4'>
                {course.curStep.title}
              </Typography>
            </Grid>
            <Grid xs={12} mb={3} item>
              <QuizSettings course={course} />
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth='md'>
          {quiz.tasks.map((task) => (
            <EditorQuizTask key={task.id} task={task} course={course} />
          ))}
          {course?.canEdit && 
            <Box mt={4} display='flex' justifyContent='center'>
              <Button
                variant   = 'contained'
                onClick   = {() => course.getCurStep.quiz.addTask()}
                startIcon = {<Icon iconId='add' />}
              >
                {t('add_question')}
              </Button>
            </Box>
          }
        </Container>
      </>
    )
  }
)
